import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from 'react'

import { ReceivingOptions } from '@/types/fees'

interface Context {
  receivingOption: ReceivingOptions
  receivingOptionText: string
  setReceivingOption(value: ReceivingOptions): void
}

const ReceivingOptionContext = React.createContext({} as Context)

const receivingOptionTextMap = {
  [ReceivingOptions.SameDay]: 'No mesmo dia',
  [ReceivingOptions.OneMonth]: '30 dias',
  [ReceivingOptions.OneBusinessDay]: '1 dia útil'
}

export function getReceivingOptionText(receivingOption: ReceivingOptions) {
  return receivingOptionTextMap[receivingOption]
}

export function useReceivingOption() {
  return useContext(ReceivingOptionContext)
}

export function ReceivingOptionContextProvider({
  children
}: {
  children: React.ReactNode
}) {
  const router = useRouter()
  const [receivingOption, setReceivingOption] = useState(
    ReceivingOptions.OneBusinessDay
  )

  useEffect(() => {
    const userAnticipation = Array.isArray(router.query.userAnticipation)
      ? router.query.userAnticipation[0]
      : router.query.userAnticipation

    if (!userAnticipation) return

    setReceivingOption(parseInt(userAnticipation, 10))
  }, [router?.query?.userAnticipation])

  const receivingOptionText = getReceivingOptionText(receivingOption)

  return (
    <ReceivingOptionContext.Provider
      value={{ receivingOptionText, receivingOption, setReceivingOption }}
    >
      {children}
    </ReceivingOptionContext.Provider>
  )
}
